// IMPORT into theme.liquid
// <script src="{{ 'gdc-component-slider-testimonials.js' | asset_url }}" defer="defer"></script>

let testimonialSlideIndex = 1
showSlides(testimonialSlideIndex)

// Next/previous controls
function moveSlides(n) {
  showSlides((testimonialSlideIndex += n))
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides((testimonialSlideIndex = n))
}

function showSlides(n) {
  let i
  const slides = document.getElementsByClassName('gdc-slider-testimonials__slide')
  const dots = document.getElementsByClassName('gdc-testimonial-dot')

  if (n > slides.length) {
    testimonialSlideIndex = 1
  }
  if (n < 1) {
    testimonialSlideIndex = slides.length
  }
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = 'none'
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(' gdc-active-dot', '')
  }

  if (slides) {
    slides[testimonialSlideIndex - 1].style.display = 'flex'
    dots[testimonialSlideIndex - 1].className += ' gdc-active-dot'
  }
}
